import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { AbstractControlValueAccessorComponent } from './abstracts/abstract-control-value-accessor.component';
import {
    BtnToggleButtonComponent,
    BtnToggleDirective,
    BtnToggleLegendDirective,
    CheckboxComponent,
    DateComponent,
    DatepickerComponent,
    ErrorBoxComponent,
    InputComponent,
    RadioComponent,
    RadioGroupDirective,
    RadioMainLabelDirective,
    SelectComponent,
    TextAreaComponent,
    TimeComponent,
} from './components';
import { PxHintRowDirective, PxInputPatternDirective } from './directives';
import { NgxMaskModule } from 'ngx-mask';

@NgModule({
    declarations: [
        InputComponent,
        RadioComponent,
        RadioGroupDirective,
        RadioMainLabelDirective,
        BtnToggleDirective,
        BtnToggleLegendDirective,
        BtnToggleButtonComponent,
        BtnToggleLegendDirective,
        DatepickerComponent,
        SelectComponent,
        TextAreaComponent,
        CheckboxComponent,
        TimeComponent,
        ErrorBoxComponent,
        DateComponent,
        PxInputPatternDirective,
        PxHintRowDirective,
        AbstractControlValueAccessorComponent,
    ],
    imports: [CommonModule, FormsModule, NgxMaskModule.forRoot()],
    exports: [
        InputComponent,
        RadioComponent,
        RadioGroupDirective,
        RadioMainLabelDirective,
        BtnToggleDirective,
        BtnToggleButtonComponent,
        BtnToggleLegendDirective,
        PxHintRowDirective,
        DatepickerComponent,
        SelectComponent,
        TextAreaComponent,
        CheckboxComponent,
        TimeComponent,
        ErrorBoxComponent,
        DateComponent,
        PxInputPatternDirective,
    ],
})
export class PxFormsModule {}
